import { axios } from "../../config/axios";

export const ReportAPI = {
  /**
   * Fetches all event types for event dropdown
   */
  fetchImpactReportEventTypes() {
    return axios.get(`/api/v3/reports/options?report[type]=Reports::ImpactReport`)
      .then((resp) => resp.data.event_types);
  },
  /**
   * Fetches all available KPIs for kpi dropdown
   */
  fetchKpis() {
    return axios.get('/api/v3/reports/assessments?report[type]=Reports::ImpactReport')
      .then((resp) => resp.data);
  },
  /**
   * Creates a new report based on selected criteria
   * @param {Object} options - an object containing all the required params when running a new report
   */
  postImpactReportJob(options) {
    return axios.post(`/api/v3/reports`, options)
      .then((resp) => resp.data.report);
  },
  /**
   * Fetches a report by id
   * @param {number} reportId - report id
   */
  fetchReport(reportId) {
    return axios.get(`/api/v3/reports/${reportId}`)
      .then((resp) => resp.data);
  },
  /**
   * Generates a downloadable report
   * @param {number} reportId - report id
   */
  generateReport(reportId) {
    return axios.post(`/api/v3/reports/${reportId}/generate_export`)
      .then((resp) => resp.data);
  },
  /**
   * Creates a new group, used to populate the merchantSegmentId in createCampaign()
   * @param {number} reportId - report id
   * @param {boolean} variant - dictates if a header column is qualified or unqualified
   * @param {string} title - name given to a new group
   */
  createSegment(reportId, variant, title) {
    return axios.post(`/api/v3/reports/${reportId}/create_segment?variant=${variant}&title=${title}`)
      .then((resp) => resp.data);
  },
  /**
   * Creates campaign, populates with selected options and returns campaign id to redirect to new campaign page
   * @param {number} merchantSegmentId - merchant id
   */
  async createCampaign(merchantSegmentId) {
    const { data } = await axios.post(`/api/v3/campaigns`)
    await axios.patch(`/api/v3/campaigns/${data.campaign.id}/update_groups?campaign[merchant_segment_ids][]=${merchantSegmentId}`)
    return data.campaign.id
  },
  /**
   * Fetches reports with the status of 'in progress' for the impact report index page
   */
  fetchInProgress() {
    return axios.get(`/api/v3/reports`, {
      params: {
        'report[type]': 'Reports::ImpactReport',
        page: 1,
        per_page: 100,
        'report[state]': ['unstarted', 'running']
      }
    }).then((resp) => resp.data);
  },
  /**
   * Fetches reports with the status of 'completed' for the impact report index page
   * @param {number} pageNumber - page number for pagination
   */
  fetchCompleted(pageNumber) {
    return axios.get(`/api/v3/reports`, {
      params: {
        'report[type]': 'Reports::ImpactReport',
        page: pageNumber + 1,
        per_page: 10,
        'report[state][]': 'completed'
      }
    }).then((resp) => resp.data);
  },
  /**
   * Deletes report with the given reportId.
   * @param {number} reportId - id of the report
   */
  deleteReport(reportId) {
    return axios.delete(`/api/v3/reports/${reportId}`).then(resp => resp.data)
  },
  /**
   * Fetches all event types for inquiry dropdown
   */
   fetchInquiryReportEventTypes() {
    return axios.get(`/api/v3/reports/options?report[type]=Reports::ImpactInquiryReport`)
      .then((resp) => resp.data.inquiry_types);
  },
  /**
   * Fetches all event kpis for inquiry dropdown
   */
  fetchInquiryReportKpis() {
    return axios.get(`/api/v3/reports/options?report[type]=Reports::ImpactInquiryReport`)
      .then((resp) => resp.data.inquiry_kpis);
  },
  /**
   * Fetches inquiry report
   */
  postInquiryReportJob(options) {
    return axios.post(`/api/v3/reports`, options)
    .then((resp) => resp.data.report);
  }
};
